import { faBan } from '@fortawesome/pro-solid-svg-icons';
import { DialogProps } from '@reach/dialog';
import { FC } from 'react';
import { CancelAssignmentRequest } from 'src/apis/monolith/use-cancel-assignment';
import { Button } from 'src/components/buttons-and-actions/button';
import { Stack } from 'src/components/layout/stack';
import { Modal } from 'src/components/overlay/modal';
import { useCountdown } from 'src/hooks/use-timer';

type Props = Pick<DialogProps, 'onDismiss'> & {
  cancelAssignment: CancelAssignmentRequest;
  organisationName: string;
  userName: string;
};

export const CancelAssignmentModal: FC<Props> = ({
  onDismiss,
  cancelAssignment,
  userName,
  organisationName,
}) => {
  const seconds = useCountdown();
  return (
    <Modal title="Cancel Assignment" icon={faBan} onDismiss={onDismiss}>
      <Stack gap={1.5}>
        <p data-testid="cancel-assignment-modal-description">
          Please, confirm that you want to cancel assignment of{' '}
          <strong>{userName}</strong> to <strong>{organisationName}</strong>.
        </p>

        <Stack flow="column" justifyContent="space-between" gap={1}>
          <Button mode="secondary" onClick={onDismiss}>
            Cancel
          </Button>

          <Button
            mode="primary"
            disabled={cancelAssignment.pending || seconds !== 0}
            onClick={() => cancelAssignment.execute()}
            data-testid={seconds === 0 ? 'cancel-assignment-submit' : undefined}
          >
            {seconds
              ? `Wait ${seconds}s to proceed...`
              : cancelAssignment.pending
              ? 'Processing...'
              : 'Cancel Assignment'}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
